module.exports = __webpack_public_path__ + "img/白色猫咪.c0467767.png";